module.exports = __webpack_public_path__ + "static/fonts/AmwayIcons.4a51a7d.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/nutrilite/relayevent/font/AmwayIcons.woff?5v2gxx
// module id = l7q2
// module chunks = 0